var set = require('regenerate')();

set.addRange(0xA800, 0xA82B);
module.exports = set;